import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useParams, Navigate } from 'react-router-dom';
import Layout from './Layout/Layout';
import Home from './Home';
import About from './About';
import Recognition from './Recognition';
import Blog from './Blog';
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

import Product from './Product';
import Post from './Blog/Post';
import FAQ from './FAQ';
import MultifamilyEVCharging from './Product_/MultifamilyEVCharging';
import CommercialEVCharging from './Product_/CommercialEVCharging';
import OCPPManagementSoftware from './Product_/OCPPManagementSoftware';
import Purchase from './Product_/Purchase';
import ROI from './Product_/ROI';
import { ToastContainer } from 'react-toastify';
import PageNotFound from './PageNotFound';
import University from './Product_/University';
import ApolloTracker from './ApolloTracker';
import Login from './Admin/Login';

import AdminLayout from './Admin/Layout';
import AdminHome from './Admin/Home';

import AdminBlogs from './Admin/Blogs';
import AdminCreateBlog from './Admin/Blogs/BlogCreate';
import AdminEditBlog from './Admin/Blogs/BlogEdit';

import AdminContact from './Admin/Contacts';

import AdminRecognitions from './Admin/Recognitions';
import AdminCreateRecognition from './Admin/Recognitions/RecognitionCreate';
import AdminEditRecognition from './Admin/Recognitions/RecognitionEdit';

import Blogs from './Blogs/Blogs';
import BlogView from './Blogs/BlogView';
import PartnerWithUs from './PartnerWithUs/PartnerWithUs';
import UploadedImages from './Admin/UploadedImages';
import CreateImageUpload from './Admin/UploadedImages/CreateImageUpload';



// import Template from './Admin/Template/';

function App() {


  return (
    <div className="App">
      <ApolloTracker />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index path="/" element={<Home />} />
            {/* <Route index path="/about" element={<About />} /> */}
            <Route index path="/product" element={<Product />} />
            <Route index path="/press" element={<Recognition />} />
            <Route index path="/blog" element={<Blog />} />
            <Route index path="/blogs" element={<Blogs />} />
            <Route index path="/blogs/:slug" element={<BlogView />} />
            <Route path="/about" element={<Navigate to="/" replace />} />

            <Route index path="/partner-with-us" element={<PartnerWithUs />} />
            

            <Route index path="/faq" element={<FAQ />} />
            <Route index path="/blog/:slug" element={<Post />} />

            <Route index path="/product/multifamily-ev-charging" element={<MultifamilyEVCharging />} />
            <Route index path="/product/university-ev-charging" element={<University />} />
            <Route index path="/product/commercial-ev-charging" element={<CommercialEVCharging />} />
            <Route index path="/product/ocpp-management-software" element={<OCPPManagementSoftware />} />
            <Route index path="/product/purchase" element={<Purchase />} />
            <Route index path="/product/purchase/:propertyType" element={<Purchase />} />
            <Route index path="/product/BERT" element={<ROI />} />

            <Route index path="*" element={<PageNotFound />} />

          </Route>
          <Route index path="/breathe-ev-admin/login" element={<Login />} />
          <Route path="/breathe-ev-admin/" element={<AdminLayout />}>
            <Route path="" element={<AdminHome />} />
            
            <Route path="blogs" element={<AdminBlogs />} />
            <Route path="blogs/create" element={<AdminCreateBlog />} />
            <Route path="blogs/edit/:id" element={<AdminEditBlog />} />

            <Route path="recognitions" element={<AdminRecognitions />} />
            <Route path="recognitions/create" element={<AdminCreateRecognition />} />
            <Route path="recognitions/edit/:id" element={<AdminEditRecognition/>} />

            <Route path="contacts" element={<AdminContact />} />

            <Route path="uploadedImages" element={<UploadedImages />} />
            <Route path="uploadedImages/create" element={<CreateImageUpload />} />

          </Route>
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </div>
  );
}

export default App;
